import { FC } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Typography } from '@altermaind/web/ui';

type Props = {
  templateName?: string;
};

export const ResultsNotVisible: FC<Props> = ({ templateName }) => {
  const t = useTranslations('department.details.assessment.noResultsVisible');

  return (
    <Box mt='l' textAlign='center'>
      <Typography variant='h3'> {t('title', { templateName })}</Typography>
      <Typography mb='s' variant='p3/light'>
        {t('description')}
      </Typography>
    </Box>
  );
};
